import category from "./category.json";
import special from "./special.json";
import wishlist from "./wishlist.json";
import returnState from "./return.json";
import manufacturerList from "./manufacturerList.json";
import manufacturer from "./manufacturer.json";
export default {
  category,
  special,
  wishlist,
  returnState,
  manufacturerList,
  manufacturer,
};
